import { usePantallaPago } from 'contexts/FormPagoContext';
import useCustomRouter from 'hooks/useCustomRouter';
import useQueryParams from 'hooks/useQueryParams';
import React, { useMemo } from 'react';
import PRODUCTOS from 'utils/constants/PRODUCTOS';

const BottomButtonsPagoRealizado = () => {
  const history = useCustomRouter();

  const { codProducto } = useQueryParams();

  const { newRoutes, loadingForm, catalogo } = usePantallaPago();

  const onClickPrint = () => {
    window.print();
  };

  const onClickContinuar = () => {
    console.log(newRoutes);
    if (codProducto === PRODUCTOS.APINDIVIDUAL) {
      return history.push(newRoutes.suscripcion.goTo);
    }
    history.push('/');
  };

  const labelContinuar = useMemo(() => {
    if (codProducto === PRODUCTOS.APINDIVIDUAL) {
      return 'CONTINUAR';
    }
    return 'VOLVER AL INICIO';
  }, []);

  return (
    <div className="row justify-content-center">
      <div className="col-sm-11 col-lg-10">
        <div className="row justify-content-around">
          <div className="col-11 col-md-6 col-lg-5">
            {!catalogo?.urlComprobante && (
              <button
                className="btn btn-primary btn-block d-flex justify-content-center flex-row align-items-center"
                onClick={onClickPrint}
                disabled={loadingForm}
              >
                DESCARGAR COMPROBANTE
              </button>
            )}
            {catalogo?.urlComprobante && (
              <a
                href={catalogo?.urlComprobante}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary-400 btn-wrap link-donwload"
              >
                DESCARGAR COMPROBANTE
              </a>
            )}
          </div>
          <div className="col-11 col-md-6 col-lg-5">
            <button
              className="btn btn-primary btn-block d-flex justify-content-center flex-row align-items-center"
              onClick={onClickContinuar}
              disabled={loadingForm}
            >
              {labelContinuar}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomButtonsPagoRealizado;
